// extracted by mini-css-extract-plugin
export default {"menuContainer":"LinksMenu_menuContainer__Wd8t3"};